// Footer.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import logo from '../components/images/logo.png';


export default function Footer() {
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    // key 
    const formDataToSend = new FormData();
    formDataToSend.append('access_key', 'a11f9e61-43b5-45a4-83ad-a7cf07265ea9');
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('phone', formData.phone);
    formDataToSend.append('subject', formData.subject);
    formDataToSend.append('message', formData.message);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setShowSuccess(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });

        // اخفي رسالة  5 ثواني
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (

    <>
      {/* Contact Section */}
      <section className="contact_us" id="Contact us">
        <h2 className="title">{t('Footer.GetInTouch')}</h2>
        <div className="line">
          <hr />
        </div>
        <div className="line_1">
          <hr />
        </div>

        <div className="container">
          <div className="social_links_contact">
            <div className="links">
              <a href="tel:+90 507 652 60 51">
                <i className="fa-solid fa-phone"></i>{t('Footer.CallUs')} <span dir="ltr">+90 507 652 60 51</span>
              </a>
              <a href="mailto:engpihub@gmail.com">
                <i className="fa-solid fa-envelope"></i>{t('Footer.Email')} engpihub@gmail.com
              </a>
              <a href="#">
                <i className="fa-solid fa-location-dot"></i>{t('Footer.Location')}
              </a>
            </div>


            <div className="logo_container">
              <img src={logo} alt="Company Logo" />
            </div>

            {/* أيقونات مواقع التواصل الاجتماعي */}
            <div className="social_media_icons">
              <a href=" https://www.instagram.com/engpihub?igsh=MTF4NHg4M2h2azUzbg==" target="_blank" rel="noopener noreferrer" className="social_icon instagram">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="https://wa.me/+90 507 652 60 51" target="_blank" rel="noopener noreferrer" className="social_icon whatsapp">
                <i className="fa-brands fa-whatsapp"></i>
              </a>
              <a href="https://www.facebook.com/share/1CA59rne9c/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social_icon facebook">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="https://t.me/engpihub" target="_blank" rel="noopener noreferrer" className="social_icon telegram">
                <i className="fa-brands fa-telegram"></i>
              </a>
              <a href="https://www.youtube.com/@engpihub" target="_blank" rel="noopener noreferrer" className="social_icon youtube">
                <i className="fa-brands fa-youtube"></i>
              </a>
              <a href="http://linkedin.com/in/engpihub" target="_blank" rel="noopener noreferrer" className="social_icon linkedin">
                <i className="fa-brands fa-linkedin-in"></i>
              </a>
            </div>
          </div>

          <form className="form_contact" onSubmit={handleSubmit}>
            <div className="inputs_form">
              <input
                type="text"
                name="name"
                placeholder={t('Footer.YourName')}
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder={t('Footer.YourEmail')}
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder={t('Footer.PhoneNumber')}
                value={formData.phone}
                onChange={handleChange}
                required
                style={{ textAlign: i18n.language === 'ar' ? 'right' : 'left' }}
              />
              <input
                type="text"
                name="subject"
                placeholder={t('Footer.Subject')}
                value={formData.subject}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                rows="10"
                placeholder={t('Footer.YourMessage')}
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit" className="btn_cta_contact">
              {t('Footer.SubmitForm')}
            </button>

            {showSuccess && (
              <div className="success-message">
                {t('Footer.SuccessMessage')}
              </div>
            )}

            {/* أيقونات السوشيال ميديا للديسكتوب */}
            <div className="social_media_icons">
              <a href="https://www.instagram.com/engpihub?igsh=MTF4NHg4M2h2azUzbg==" target="_blank" rel="noopener noreferrer" className="social_icon instagram">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="https://wa.me/90 507 652 60 51" target="_blank" rel="noopener noreferrer" className="social_icon whatsapp">
                <i className="fa-brands fa-whatsapp"></i>
              </a>
              <a href="https://www.facebook.com/share/1CA59rne9c/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social_icon facebook">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="https://t.me/engpihub" target="_blank" rel="noopener noreferrer" className="social_icon telegram">
                <i className="fa-brands fa-telegram"></i>
              </a>
              <a href="https://www.youtube.com/@engpihub" target="_blank" rel="noopener noreferrer" className="social_icon youtube">
                <i className="fa-brands fa-youtube"></i>
              </a>
              <a href="http://linkedin.com/in/engpihub" target="_blank" rel="noopener noreferrer" className="social_icon linkedin">
                <i className="fa-brands fa-linkedin-in"></i>
              </a>
            </div>
          </form>
        </div>
      </section>

    </>
  );
}
